export default __webpack_public_path__ + "static/bogdan-shkarupa-a1896dc77a2444e90a75013f61b7f0cb.png";